<template>
  <div id="app">
    <vueSignature
      ref="signature"
      :sigOption="option"
      :h="'200px'"
      :disabled="isDisabled"
      style="border: 1px solid #e4e4e4;"
    />
    <div
      v-if="isDisabled"
      class="change-signature-btn"
    >
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        variant="outline-primary"
        :disabled="!isDisabled"
        @click="changeClicked"
      >
        {{ $t('DEBTIA_SAVE_BTN') }}
      </b-button>
    </div>
    <div
      v-else
      class="signature-btns"
    >

      <!-- default -->
      <b-button-group
        class="my-1"
      >
        <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          variant="outline-primary"
          :disabled="isDisabled"
          @click="save(false)"
        >
          {{ $t('DEBTIA_SAVE_BTN') }}
        </b-button>
        <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          variant="outline-primary"
          :disabled="isDisabled"
          @click="clear"
        >
          {{ $t('DEBTIA_CLEAR_BTN') }}
        </b-button>
        <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          variant="outline-primary"
          :disabled="isDisabled"
          @click="undo"
        >
          {{ $t('DEBTIA_UNDO_BTN') }}
        </b-button>
      </b-button-group>
      <b-button
        v-if="!newSaved && signature"
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        variant="outline-primary"
        :disabled="isDisabled"
        style="margin-left: 8%;"
        @click="clickPrevious"
      >
        Previous Signature
      </b-button>
    </div>
  </div>
</template>
<script>

import i18n from '@/libs/i18n'
import vueSignature from 'vue-signature'
import { BButtonGroup, BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import axiosIns from '../../../libs/axios'

export default {
  components: {
    vueSignature,
    BButtonGroup,
    BButton,
  },
  directives: {
    Ripple,
  },
  props: {
    base64Signature: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isDisabled: false,
      changeBtnEventCalled: false,
      option: {
        penColor: 'rgb(0, 0, 0)',
        backgroundColor: 'white',
      },
      signature: this.base64Signature,
      newSaved: false,
    }
  },
  created() {
    if (this.signature) {
      this.isDisabled = true
      setTimeout(() => { this.fromDataURL() }, 1000)
    }
  },
  methods: {
    makeToast(variant = null, msg = null) {
      this.$bvToast.toast(msg, {
        title: i18n.t('DEBTIA_MESSAGE_TEXT'),
        variant,
        solid: false,
      })
    },
    popToken() {
      let token = window.location.href.split('/')
      token = token.pop()
      let urlToken = null
      if (token.includes('?')) {
        const fullResult = token.split('?')
        // eslint-disable-next-line prefer-destructuring
        urlToken = fullResult[0]
      } else {
        urlToken = token
      }
      return urlToken
    },
    async save(parentcall = null) {
      const png = this.$refs.signature.save()
      const jpeg = this.$refs.signature.save('image/jpeg')
      let svg = ''
      if (!this.changeBtnEventCalled && this.signature) {
        svg = this.signature
      } else {
        svg = this.$refs.signature.save('image/svg+xml')
      }
      console.log(png)
      console.log(jpeg)
      console.log(svg)
      let endresult = false
      if (!this.$refs.signature.isEmpty()) {
        this.$emit('spintoggle', true)
        const token = this.popToken()
        await axiosIns.post('installment_plan/preserve_action', {
          token,
          action: 'save_signature',
          signature: svg,
        })
        this.$emit('spintoggle', false)
        this.makeToast('success', i18n.t('DEBTIA_SIGNATURE_SAVE_RESPONSE'))
        endresult = true
        this.newSaved = true
      } else {
        console.log('in else', endresult)
        if (!parentcall) {
          this.makeToast('danger', i18n.t('DEBTIA_SIGNATURE_ERROR_MSG'))
        }
      }
      return endresult
    },
    clear() {
      this.isDisabled = false
      this.$refs.signature.clear()
    },
    undo() {
      this.$refs.signature.undo()
    },
    fromDataURL() {
      this.$refs.signature.fromDataURL(this.signature)
    },
    changeClicked() {
      this.changeBtnEventCalled = true
      this.clear()
    },
    clickPrevious() {
      this.fromDataURL()
      this.changeBtnEventCalled = false
      this.isDisabled = true
    },
  },
}
</script>
<style scoped>
  @media only screen and (max-width: 767px){
    .signature-btns{
        margin-left: 27px !important;
    }
    .change-signature-btn{
      margin-left: 50px !important;
      margin-top: 15px !important;
    }
  }
  @media only screen and (min-width: 767px){
    .signature-btns{
        margin-left: 80px !important;
    }

    .change-signature-btn{
      margin-left: 100px !important;
      margin-top: 15px !important;
    }
  }
</style>
